import React from 'react'
import {Typography} from '@mui/material'
import moment from 'moment'
import {ColumnDef} from 'src/components-new/data/DataTable'
import StatusPill from 'src/components-new/primitives/StatusPill'
import {ColumnConfig, getPatientEnrollmentStatusColor, getPatientEnrollmentStatusLabel} from './enrollmentHubOptions'

export interface PatientEnrollmentRow {
  _id: string
  firstName?: string
  lastName?: string
  birthDate?: string
  createdAt?: string
  status?: string
  [key: string]: any
}

// Same value/label pairs as the legacy table
// (src/components/templates/EnrollmentPatientTable/EnrollmentPatientTable.tsx lines 36-61).
export const DEFAULT_COLUMNS: ColumnConfig[] = [
  {id: 'lastName', label: 'Cognome Paziente'},
  {id: 'firstName', label: 'Nome Paziente'},
  {id: 'birthDate', label: 'Data di nascita'},
  {id: 'createdAt', label: 'Data invio richiesta'},
  {id: 'status', label: 'Stato'},
]

function renderCell(id: string) {
  return (row: PatientEnrollmentRow): React.ReactNode => {
    if (id === 'birthDate') {
      return <Typography variant="body2">{row.birthDate ? moment(row.birthDate).format('ddd DD MMM YYYY') : '—'}</Typography>
    }
    if (id === 'createdAt') {
      return <Typography variant="body2">{row.createdAt ? moment(row.createdAt).format('ddd DD MMM YYYY HH:mm') : '—'}</Typography>
    }
    if (id === 'status') {
      return <StatusPill label={getPatientEnrollmentStatusLabel(row.status)} color={getPatientEnrollmentStatusColor(row.status)} />
    }
    return <Typography variant="body2">{(row as any)[id] ?? '—'}</Typography>
  }
}

/**
 * Columns are PSP-driven (`enrollmentHubConfigurations.patientEnrollmentConfigurations.columnOptions`),
 * falling back to a sensible default set — mirrors the pattern in
 * echocardiographicRequestsColumns.tsx. `status` renders as the mobile card's top-right
 * badge; there's no `mobileCardHeader` column, so the header stays limited to that badge
 * and `lastName` renders as an ordinary labeled field in the card body (see DataTable's
 * mobile-card fallback when no column claims the header slot).
 */
export function buildColumns(columnConfig?: ColumnConfig[]): ColumnDef<PatientEnrollmentRow>[] {
  const config = columnConfig && columnConfig.length > 0 ? columnConfig : DEFAULT_COLUMNS
  return config.map((col, index) => ({
    key: `${col.id}-${index}`,
    header: col.label,
    mobileCardBadge: col.id === 'status',
    sortKey: col.id,
    render: renderCell(col.id),
  }))
}
